import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tag mr-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("—")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ItemId = _resolveComponent("ItemId")!

  return (_ctx.modelVersion)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.modelVersion.tag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.modelVersion.tag), 1))
          : _createCommentVNode("", true),
        (_ctx.modelVersion)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'model-version', params: { versionId: _ctx.modelVersion.id } },
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.truncateShort(_ctx.modelVersion.model.name)), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _hoisted_2,
        _createElementVNode("small", null, [
          _createVNode(_component_ItemId, {
            "item-id": _ctx.modelVersion.id
          }, null, 8, ["item-id"])
        ])
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _hoisted_3
      ], 64))
}